export const RESET = 'EXSBPRICELIST_LIST_RESET'
export const SET_ITEMS = 'EXSBPRICELIST_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBPRICELIST_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBPRICELIST_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBPRICELIST_LIST_TOGGLE_LOADING'
